import apiClient from '@/services/axios'
import { notification } from 'ant-design-vue'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

const getProgramParams = async (programId) => {
  try {
    const url = `${referralApiUrl}/referral-programs/${programId}`
    const response = await apiClient.get(url)
    if (response?.data?.data) {
      return response.data.data
    }
    getErrorMessage(response?.data)
    return null
  } catch (e) {
    notification.error({
      message: e?.message ? e.message : 'Error',
    })
  }
}

export { getProgramParams }
